import type { FunctionComponent } from "react";
import styles from "./TextImageListBlock.module.sass";
import type { ImageResult } from "../data/ImageFragment";
import type { LinkResult } from "../data/LinkFragment";
import Image from "next/image";
import Link from "next/link";
import type { TextImageListItemResult } from "../data/TextImageListFragment";

export type TextImageItem = {
	id: string;
	image: ImageResult;
	text: string;
	link?: LinkResult;
};

export type TextImageListBlockProps = {
	title?: string;
	items: TextImageListItemResult[];
};

export const TextImageListBlock: FunctionComponent<TextImageListBlockProps> = ({
	title,
	items,
}) => {
	return (
		<div className={styles.wrapper}>
			{title && <h2 className={styles.title}>{title}</h2>}
			<ul className={styles.list}>
				{items.map((item) => {
					const tileContent = (
						<div className={styles.textImageTile}>
							{item.image && (
								<div className={styles.imageContainer}>
									<Image
										className={styles.image}
										src={item.image.url}
										width={item.image.width}
										height={item.image.height}
										alt={item.image.alt ?? ""}
										sizes="120px"
									/>
								</div>
							)}
							<p className={styles.text}>{item.text}</p>
						</div>
					);

					return (
						<li key={item.id} className={styles.item}>
							{item.link ? (
								<Link
									target={item.link.internalLink ? "_self" : "_blank"}
									href={
										item.link.internalLink
											? item.link.internalLink.url
											: (item.link.externalLink ?? "")
									}
									className={styles.link}
								>
									{tileContent}
								</Link>
							) : (
								tileContent
							)}
						</li>
					);
				})}
			</ul>
		</div>
	);
};
